import loadable from '@loadable/component';

import withStickyBehaviorSearch from './withStickyBehaviorSearch';

const ConsumerHeader = loadable(() => import('./ConsumerHeader'));

export default withStickyBehaviorSearch(ConsumerHeader);
